// extracted by mini-css-extract-plugin
export default {"sectionTitle":"TheaterScreeningsList_sectionTitle__oBPic","theaterName":"TheaterScreeningsList_theaterName__SDaIK","showtimesSection":"TheaterScreeningsList_showtimesSection__9A3Ye"};